import React, { useState, useEffect } from "react";
import { getLatestDocuments } from "../../services/DocumentService";
import { useNavigate } from "react-router-dom";

const RightList = ({ fullWidth = false }) => {
  const [loading, setLoading] = useState(true);
  const [documents, setDocuments] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchLatestDocuments();
  }, []);

  const fetchLatestDocuments = async () => {
    try {
      setLoading(true);
      const response = await getLatestDocuments(7);
      setDocuments(response.data || []);
    } catch (error) {
      console.error("Error fetching latest documents:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDocumentClick = (doc) => {
    navigate(`/materials/${doc._id}`);
  };

  if (loading) {
    return (
      <div
        className={`relative bg-[#f6d2df] rounded-md p-8 w-full ${
          fullWidth ? "max-w-none" : "max-w-[320px]"
        } shadow-xl`}
      >
        <div className="absolute inset-0 bg-white/50 backdrop-blur-sm animate-pulse" />
        <div className="relative z-10">
          <div className="w-[193px] h-[24px] bg-gray-300 rounded mb-4" />
          <div className="space-y-3">
            {[...Array(7)].map((_, index) => (
              <div key={index} className="flex items-center gap-3 p-2">
                <div className="w-[32px] h-[32px] rounded bg-gray-300 flex-shrink-0" />
                <div className="w-[133px] h-[21px] bg-gray-300 rounded" />
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`bg-[#f6d2df] rounded-md p-8 w-full ${
        fullWidth ? "max-w-none" : "max-w-[320px]"
      } shadow-xl`}
    >
      <div className="text-[#4b4b4b] font-extrabold mb-4">
        ĐỀ THI THỬ MỚI NHẤT
      </div>
      <div className="space-y-3">
        {documents.length > 0 ? (
          documents.map((doc, index) => (
            <div
              key={doc._id}
              className="flex items-center gap-3 cursor-pointer hover:bg-[#f9dfe8] p-2 rounded-md transition-colors"
              onClick={() => handleDocumentClick(doc)}
            >
              <div className="w-8 h-8 rounded bg-[#db3b6d] text-white flex items-center justify-center text-sm font-bold flex-shrink-0">
                {index + 1}
              </div>
              <div className="text-[14px] text-[#4b4b4b] truncate">
                {doc.title}
              </div>
            </div>
          ))
        ) : (
          <div className="text-center text-sm text-gray-500 py-4">
            Chưa có đề thi nào
          </div>
        )}
      </div>
    </div>
  );
};

export default RightList;
